import { useCallback, useState } from "react";
import { useAuthUserQuery, useUpdateRecommendArticleMutation } from "@/hooks";

/**
 * useViewingArticle.
 * 会員登録完了後の挙動を設定する
 */
export function useViewingArticle() {
  const {
    0: sending,
    1: setSending
  } = useState(false);
  const {
    data
  } = useAuthUserQuery({
    fetchPolicy: "cache-only"
  });
  const user = data === null || data === void 0 ? void 0 : data.user;
  const [updateRecommendArticle] = useUpdateRecommendArticleMutation();
  const setViewingArticle = useCallback(async function (_ref) {
    let {
      type,
      id
    } = _ref;
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (user) return false;
    if (!sending || force) {
      setSending(true);
      updateRecommendArticle({
        variables: {
          type,
          id
        }
      });
    }
  }, [user, sending]);
  return {
    setViewingArticle
  };
}